// @ts-nocheck

import SettingOutlined from '@ant-design/icons/SettingOutlined'

export default {
  SettingOutlined
}
    